export const queryParams = (query) => {
    if (query[0] === '?') {
      query = query.slice(1)
    }
    return query.split('&').filter(Boolean).reduce((accumulator, element) => {
      const key = element.split('=')[0]
      const value = element.split('=').slice(1).join("=")
      return { ...accumulator, [key]: value }
    }, {})
}